/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

import {Box, Stack, Tooltip, Typography} from '@mui/material';
import {useFlags} from 'launchdarkly-react-client-sdk';
import {Circle} from 'lucide-react';
import {FeatureFlagSet, FeatureFlags} from '../../../../flags';

interface AgentNameCellProps {
  name: string;
  isDefault: boolean;
  greeting?: string | null;
}

export const AgentNameCell = ({name, isDefault, greeting}: AgentNameCellProps) => {
  const flags = useFlags<FeatureFlagSet>();
  const showGreetingTooltip = flags[FeatureFlags.testAgent];

  return (
    <Stack spacing={1}>
      {showGreetingTooltip ? (
        <Tooltip
          title={
            <Box component={'span'} onClick={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()}>
              <Typography variant={'body2'}>{greeting || 'No greeting configured'}</Typography>
            </Box>
          }
          PopperProps={{
            onClick: (e) => e.stopPropagation(),
          }}
        >
          <Typography>{name}</Typography>
        </Tooltip>
      ) : (
        <Typography>{name}</Typography>
      )}
      {isDefault && (
        <Typography variant={'caption'} color={'success.main'} sx={{display: 'flex', alignItems: 'center', gap: 0.5}}>
          <Circle size={8} /> Default Agent
        </Typography>
      )}
    </Stack>
  );
};
